import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SeatmapResultEffect } from './seatmap-result.effect';
import { seatmapResultReducer } from './seatmap-result.reducer';
import { SEATMAP_RESULT_STORE_NAME, SeatmapResultState } from './seatmap-result.state';

/** Token of the SeatmapResult reducer */
export const SEATMAP_RESULT_REDUCER_TOKEN = new InjectionToken<ActionReducer<SeatmapResultState, Action>>(
  'Feature SeatmapResult Reducer'
);

/** Provide default reducer for SeatmapResult store */
export function getDefaultSeatmapResultReducer() {
  return seatmapResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(SEATMAP_RESULT_STORE_NAME, SEATMAP_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([SeatmapResultEffect]),
  ],
  providers: [{ provide: SEATMAP_RESULT_REDUCER_TOKEN, useFactory: getDefaultSeatmapResultReducer }],
})
export class SeatmapResultStoreModule {
  public static forRoot<T extends SeatmapResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<SeatmapResultStoreModule> {
    return {
      ngModule: SeatmapResultStoreModule,
      providers: [{ provide: SEATMAP_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
